import { render, staticRenderFns } from "./InstallmentPaidState.vue?vue&type=template&id=4560888b&"
import script from "./InstallmentPaidState.vue?vue&type=script&lang=js&"
export * from "./InstallmentPaidState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports